import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { TitleBar, IconClose, IconInvisible, IconLock, IconCheck, IconEdit, evenRowColor } from '../../common/theme';
import { isObjectEmpty } from '../../../Utils';
import Alert from 'react-bootstrap/Alert';

const ContainerComp = ({pageState, parentState}) =>{

    const [programData, setProgramData] = useState({});
    const [moduleData, setModuleData] = useState([]);  
    const [checkMarkData, setCheckMarkData] = useState({}); 
    const [hasPretests, setHasPretests] = useState(false);
    const [hasPosttests, setHasPosttests] = useState(false);
    const [hasAssignments, setHasAssignments] = useState(false);
    const [isPretestable, setIsPretestable] = useState(true);

    const componentData = {
        programData, setProgramData,
        moduleData, setModuleData,
        checkMarkData, setCheckMarkData,
        isPretestable, setIsPretestable,
        parentRefresh: parentState.refreshCompState, setParentRefresh: parentState.setRefreshCompState,
        studentList: parentState.studentsSelected, setStudentList: parentState.setStudentsSelected
    };

    useEffect(() => {     
        if(programData && programData.students){
            let checkMarks = {};
            programData.students.forEach(studRec=>{
                checkMarks[studRec.StudentID] = {isCheckedPretest: studRec.hasPretest, isCheckedPosttest:studRec.hasPosttest, hasPretestLocked:false, hasPosttestLocked:false};
            });
            setCheckMarkData({...checkMarks });
        }
    },[programData]);

    useEffect(() => { 
        let program = componentData.programData;
        if(isObjectEmpty(program))
            program = pageState.processedProgramAssignments.find(progRec=>progRec.id.toUpperCase() === parentState.programSelectedID.toUpperCase());

        if(program){
            if(program.id==='C4' || program.id==='C5' || program.id==='C6' ||
            program.id==='HLR2P' || program.id==='HLR3' || program.id==='HLR3P' || program.id==='HLR4' || program.id==='HLR4P' ||
            program.id==='LRP' || program.id==='LR1' || program.id==='LR2' || program.id==='LR3' ||
            program.id==='MMM' || program.id.startsWith('QUIZ') || program.id.startsWith('LESSON') || program.id.startsWith('COURSE'))
                setIsPretestable(false);            
        }
        if(!parentState.refreshCompState) return;

        let students = program.students.filter(studRec => parentState.studentsSelected.indexOf(studRec.StudentID) > -1);
        let hasPretest = (students) ? students.filter((studentRec)=>studentRec.hasPretest === true).length > 0 : false;
        setHasPretests(hasPretest);
        let hasPosttest = (students) ? students.filter((studentRec)=>studentRec.hasPosttest === true).length > 0 : false;
        setHasPosttests(hasPosttest);
        let hasAssignment = (students) ? students.filter((studentRec)=>studentRec.hasAssignment === true).length > 0 : false;
        setHasAssignments(hasAssignment);

        setProgramData({...program });
        parentState.setRefreshCompState(false);
    }); 
    
    useEffect(() => {     
        if(!pageState.resetInnerSaveState) return;
        let program = pageState.processedProgramAssignments.find(progRec=>progRec.id.toUpperCase() === parentState.programSelectedID.toUpperCase());
        setProgramData({...program });
        pageState.setResetInnerSaveState(false);
    }); 
    
    return <div><StudentModulesTableComp pageState={pageState} assignments={{hasPretests,hasPosttests,hasAssignments}} componentData={componentData} parentState={parentState} /></div>;
};

const StudentModulesTableComp = ({pageState, assignments, componentData, parentState}) => {    
    const {hasPretests,hasPosttests,hasAssignments} = assignments;
    const [isDisabledTestSave, setIsDisabledTestSave] = useState(true);

    useEffect(() => {     
        let shouldDisabledTestSave = true;
        
        if(componentData && componentData.programData && componentData.programData.students && !isObjectEmpty(componentData.checkMarkData)){
            let key = componentData.programData.students[0].StudentID;
            //console.log('key',(key in componentData.checkMarkData),key,{...componentData.checkMarkData});
            if(!(key in componentData.checkMarkData)) return;
            componentData.programData.students.forEach(studRec=>{
                // TODO: Changing classes and clicking on a program to assign too fast can sometimes not give enough time to load the new class and will crash
                if(!componentData.checkMarkData[studRec.StudentID]) { 
                    console.error('Error with componentData.checkMarkData!', studRec.StudentID, {...componentData.checkMarkData});
                    return; 
                }
                //console.log('studRec',studRec,'componentData',componentData.checkMarkData,studRec.StudentID);
                if(componentData.checkMarkData[studRec.StudentID].isCheckedPretest && !studRec.hasPretest)
                    shouldDisabledTestSave = false;
                if(!componentData.checkMarkData[studRec.StudentID].isCheckedPretest && studRec.hasPretest)
                    shouldDisabledTestSave = false;

                if(componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && !studRec.hasPosttest)
                    shouldDisabledTestSave = false;
                if(!componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && studRec.hasPosttest)
                    shouldDisabledTestSave = false;
            });
            setIsDisabledTestSave(shouldDisabledTestSave);
        }
    }); 

    const selectAll = () => {
        let cloneData = JSON.parse(JSON.stringify(componentData.programData));
        cloneData.students = cloneData.students.map(studRec=>{return{...studRec, isSelected:true};});
        componentData.setProgramData(cloneData);
        componentData.setStudentList(cloneData.students.reduce((acc, studRec)=> {
            (studRec.isSelected) && acc.push(studRec.StudentID);
            return acc;
        },[]));

        componentData.setParentRefresh(true);
    };  

    const unselectAll = () => {
        let cloneData = JSON.parse(JSON.stringify(componentData.programData));
        cloneData.students = cloneData.students.map(studRec=>{return{...studRec, isSelected:false};});
        componentData.setProgramData(cloneData);
        componentData.setStudentList(cloneData.students.reduce((acc, studRec)=> {
            (studRec.isSelected) && acc.push(studRec.StudentID);
            return acc;
        },[]));

        componentData.setParentRefresh(true);
    };

    const saveTests = () => {
        let pretestChanges = componentData.programData.students.reduce((acc,studRec)=>{
            if(componentData.checkMarkData[studRec.StudentID].isCheckedPretest && !studRec.hasPretest)
                acc.push({test:'pretest',studentID:studRec.StudentID,type:'add'});
            if(!componentData.checkMarkData[studRec.StudentID].isCheckedPretest && studRec.hasPretest)
                acc.push({test:'pretest',studentID:studRec.StudentID,type:'remove'});
            return acc;
        },[]);
        let posttestChanges = componentData.programData.students.reduce((acc,studRec)=>{
            if(componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && !studRec.hasPosttest)
                acc.push({test:'posttest',studentID:studRec.StudentID,type:'add'});
            if(!componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && studRec.hasPosttest)
                acc.push({test:'posttest',studentID:studRec.StudentID,type:'remove'});
            return acc;
        },[]);

        let allChanges = pretestChanges.concat(posttestChanges);
        allChanges = allChanges.reduce((acc,savRec)=>{
            if(savRec.type === 'add'){
                acc.push(savRec);
                return acc;
            }            
            if(!allChanges.find(e=>(e.studentID === savRec.studentID && e.type === 'add' )))
                acc.push(savRec);

            return acc;
        },[]);

        // console.log(allChanges);
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
        let buildModuleData = program.modules.reduce((acc,moduleRec)=>{acc += ';'+moduleRec[0]; return acc;},'').substr(1);
        parentState.setRequestState({progID:parentState.programSelectedID, students: allChanges, assign:'test', assignedModules:buildModuleData});

    };

    const savePretests = () => {
        let pretestChanges = componentData.programData.students.reduce((acc,studRec)=>{
            if(componentData.checkMarkData[studRec.StudentID].isCheckedPretest && !studRec.hasPretest)
                acc.push({studentID:studRec.StudentID,type:'add'});
            if(!componentData.checkMarkData[studRec.StudentID].isCheckedPretest && studRec.hasPretest)
                acc.push({studentID:studRec.StudentID,type:'remove'});
            return acc;
        },[]);
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
        let buildModuleData = program.modules.reduce((acc,moduleRec)=>{acc += ';'+moduleRec[0]; return acc;},'').substr(1);
        parentState.setRequestState({progID:parentState.programSelectedID, students: pretestChanges, assign:'pretest', assignedModules:buildModuleData});

    };

    const savePosttests = () => {
        let posttestChanges = componentData.programData.students.reduce((acc,studRec)=>{
            if(componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && !studRec.hasPosttest)
                acc.push({studentID:studRec.StudentID,type:'add'});
            if(!componentData.checkMarkData[studRec.StudentID].isCheckedPosttest && studRec.hasPosttest)
                acc.push({studentID:studRec.StudentID,type:'remove'});
            return acc;
        },[]);
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
        let buildModuleData = program.modules.reduce((acc,moduleRec)=>{acc += ';'+moduleRec[0]; return acc;},'').substr(1);
        parentState.setRequestState({progID:parentState.programSelectedID, students: posttestChanges, assign:'posttest', assignedModules:buildModuleData});

    };

    const removeAssignments = (assign, type) => {
        let assignedModules = '';

        // remove student assignments
        let studentToRemove = []; 
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
        studentToRemove = program.students.filter(studRec=>studRec.hasAssignment && parentState.studentsSelected.find(studID=>studRec.StudentID===studID)).map(studRec=>studRec.StudentID);
        parentState.setRequestState({progID:parentState.programSelectedID, students:studentToRemove, assign, type, assignedModules});
    };

    const isPretestable = () =>{
        const progID = componentData.programData.id;
        if(progID==='C4' || progID==='C5' || progID==='C6' ||
        progID==='HLR2P' || progID==='HLR3' || progID==='HLR3P' || progID==='HLR4' || progID==='HLR4P' ||
        progID==='LRP' || progID==='LR1' || progID==='LR2' || progID==='LR3' ||
        progID==='MMM' || progID.startsWith('QUIZ') || progID.startsWith('LESSON') || progID.startsWith('COURSE')) return false;
        return true;
    };
    const selectAllPretest=(type)=>()=>{
        let nextState = {};

        if (!isPretestable()) return;
        Object.keys(componentData.checkMarkData).map(key => {
            let student= componentData.programData.students.filter(studentRec=>studentRec.StudentID===key);   
            let hasPretestLocked = student[0].hasPretest;
            if(type==='add') nextState[key] = {isCheckedPretest: true, isCheckedPosttest: false, hasPretestLocked, hasPosttestLocked:false};
            if(type==='remove') nextState[key] = {isCheckedPretest: false, isCheckedPosttest: componentData.checkMarkData[key].isCheckedPosttest, hasPretestLocked:false, hasPosttestLocked:false};
        });

        componentData.setCheckMarkData(nextState);        
    };   

    const selectAllPosttest=(type)=>()=>{
        let nextState = {};

        if (!isPretestable()) return;
        Object.keys(componentData.checkMarkData).map(key => {
            let student= componentData.programData.students.filter(studentRec=>studentRec.StudentID===key);   
            let hasPosttestLocked = student[0].hasPosttest;
            if(type==='add') nextState[key] = {isCheckedPretest: false, isCheckedPosttest: true, hasPretestLocked:false, hasPosttestLocked};
            if(type==='remove') nextState[key] = {isCheckedPretest: componentData.checkMarkData[key].isCheckedPretest, isCheckedPosttest: false, hasPretestLocked:false, hasPosttestLocked:false};
        });

        componentData.setCheckMarkData(nextState);
    };   

    const resetTests=()=>{
        let nextState = {};
        if(componentData && componentData.programData && componentData.programData.students && !isObjectEmpty(componentData.checkMarkData)){
            componentData.programData.students.map(studRec=>{
                nextState[studRec.StudentID] = {
                    isCheckedPretest: studRec.hasPretest, 
                    isCheckedPosttest: studRec.hasPosttest,
                    hasPretestLocked: false,
                    hasPosttestLocked: false
                };
            });
        }
        componentData.setCheckMarkData(nextState);
    };  

    return (
        <Container>
            <Row>  
                {(parentState.studentsSelected.length ==0) && <Col xs='4'></Col>}
            </Row>            

            <TitleBar>
                <Col  style={{textAlign: 'left'}} xs='5'>Students</Col>
                <Col xs='2'>Pre-Test<br/>
                    {(parentState.studentsSelected.length===0)?<>
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAllPretest('add')}><IconCheck/></Button>&nbsp;
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={selectAllPretest('remove')}><IconClose/></Button>
                    </>:
                        <>{!parentState.madeModuleChanges?
                            <Button data-toggle={'Press to unlock tests by resetting assignment selections'} title={'Press to unlock tests by resetting assignment selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={unselectAll}><IconLock/></Button>:
                            <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} disabled><IconLock/></Button>
                        }</>
                    }
                </Col>
                <Col xs='2'>Post-Test<br/>
                    {(parentState.studentsSelected.length===0)?<>
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAllPosttest('add')}><IconCheck/></Button>&nbsp;
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={selectAllPosttest('remove')}><IconClose/></Button>
                    </>:
                        <>{!parentState.madeModuleChanges?
                            <Button data-toggle={'Press to unlock tests by resetting assignment selections'} title={'Press to unlock tests by resetting assignment selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={unselectAll}><IconLock/></Button>:
                            <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} disabled><IconLock/></Button>
                        }</>
                    }
                </Col>
                <Col xs='3'>Assign Modules<br/>
                {/* <Col style={{backgroundColor:(parentState.studentsSelected.length===0)?'#387da7':'blue'}} xs='3'>Assign Modules<br/> */}
                    {(isDisabledTestSave && !parentState.madeModuleChanges) ? <>
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAll}><IconCheck/></Button>&nbsp;
                        {/* <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={unselectAll}><IconClose/></Button>&nbsp; */}
                    </>:
                        <>{!parentState.madeModuleChanges?
                            <Button data-toggle={'Press to unlock assignments by resetting test selections'} title={'Press to unlock assignments by resetting test selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={resetTests}><IconLock/></Button>:
                            <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} disabled><IconLock/></Button>
                        }</>
                    }
                </Col>
            </TitleBar>
            <ProgramRow pageState={pageState} componentData={componentData} parentState={parentState} testsSelected={!isDisabledTestSave}/>

            <Row style={{marginTop:'10px'}}>                
                <Col xs='5'>
                    <Button disabled={isDisabledTestSave} variant={'success'} onClick={()=>saveTests()}>Save</Button>&nbsp;
                    {(!isDisabledTestSave)&&<Button variant={'danger'} onClick={resetTests}>Cancel</Button>}
                </Col>   
                <Col xs='7'>
                    {!parentState.madeModuleChanges&&<>
                        {parentState.studentsSelected.length!==0 && <Button className="pull-right" variant={'danger'} onClick={unselectAll} >Cancel</Button>}
                        {hasAssignments && <span className="pull-right"><Button variant={'primary'} disabled={!hasAssignments} onClick={()=>removeAssignments('assignments','remove')} >Remove <IconEdit style={{color:'#ffffff', paddingLeft:'3px'}}/></Button>&nbsp;</span>}
                    </>}
                </Col>
            </Row>
            <br/>
        </Container>
    );
};

StudentModulesTableComp.propTypes = {
    data: PropTypes.object
};

const ProgramRow = ({pageState, componentData, parentState, testsSelected}) => {
    let {id, title, students } = componentData.programData;  

    return (
        <Row>
            <Col style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', border: '1px solid #cfcfcf'}}>
                {!students && <>There are no assignments for this program. Please click the red back button to assign more programs</>}
                {(students) && students.map((studentRec, i) => 
                    <StudentRow key={i} index={i} pageState={pageState} studentData={studentRec} componentData={componentData} hasTestsChecked={testsSelected} hasAssignmentSelected={(parentState.studentsSelected.length>0)} parentState={parentState} />
                )}
            </Col>
        </Row>
    );
};

const StudentRow = ({pageState, studentData, componentData, index, hasTestsChecked, hasAssignmentSelected, parentState}) =>{
    const {Name: name, StudentID, hasPretest, hasPosttest, hasAssignment, isSelected, assignAuthor} = studentData;
    const {posttestChanges, pretestChanges, setPosttestChanges, setPretestChanges} = componentData;
    //const selectedStyle = (isSelected) ? {backgroundColor:'lightblue'} : (index%2==0)?{background:evenRowColor}:{};
    const backgroundStyle = (isSelected) ? '#ADD8E6' : (index%2==0)?evenRowColor:'#FFFFFF';
    const backgroundStyleGrey = (isSelected) ? 'lightgrey' : (index%2==0)?evenRowColor:'#FFFFFF';
    // const backgroundStyleGreyX = (isSelected) ? (pageState.hasMouseInsideModulesPanel)?'#ff9f9f':'grey' : '#ff9f9f';
    const backgroundStyleGreyX = '#ff4f4f';
    const selectedStyle = {backgroundColor:backgroundStyle};

    const isPretestDisabled =(studentID)=> {
        let isDisabled = false;
        if((componentData && componentData.checkMarkData && componentData.checkMarkData[studentID]))
            isDisabled = componentData.checkMarkData[studentID].hasPretestLocked; 
        if (!isDisabled) isDisabled = false;
        let hasChangedPosttest = hasChangedOn('Posttest',studentID);
        return hasAssignmentSelected || isDisabled || hasChangedPosttest;
    };
    const isPosttestDisabled =(studentID)=> {
        let isDisabled = false;
        if((componentData && componentData.checkMarkData && componentData.checkMarkData[studentID]))
            isDisabled = componentData.checkMarkData[studentID].hasPosttestLocked;
        if (!isDisabled) isDisabled = false;
        let hasChangedPretest = hasChangedOn('Pretest',studentID);
        return hasAssignmentSelected || isDisabled || hasChangedPretest;
    };
    const showCheckedAssignment=()=>{
        if(!isSelected)
            return false;
        return isSelected;
    };
    const showCheckedPretest=(studentID)=>{
        if(!(componentData && componentData.checkMarkData && componentData.checkMarkData[studentID]))
            return false;

        return componentData.checkMarkData[studentID].isCheckedPretest;        
    };
    const showCheckedPosttest=(studentID)=>{
        if(!(componentData && componentData.checkMarkData && componentData.checkMarkData[studentID]))
            return false;

        return componentData.checkMarkData[studentID].isCheckedPosttest;        
    };

    const onChangeHandlerPretest=(studentID)=>(event)=>{
        // console.log(componentData.checkMarkData[studentID]);
        componentData.setCheckMarkData({...componentData.checkMarkData, [studentID]:{isCheckedPretest:event.target.checked, isCheckedPosttest: false}});
    };    

    const onChangeHandlerPosttest=(studentID)=>(event)=>{
        // console.log(componentData.checkMarkData[studentID]);
        componentData.setCheckMarkData({...componentData.checkMarkData, [studentID]:{isCheckedPretest:false, isCheckedPosttest: event.target.checked}});
    };    

    const toggleSelected = (studentID) => {
        if(hasTestsChecked) return;
        if(parentState.madeModuleChanges) return;
        
        let cloneData = JSON.parse(JSON.stringify(componentData.programData));
        let currentStudent = cloneData.students.find(studRec=>studRec.StudentID===studentID);
        currentStudent.isSelected = !currentStudent.isSelected;
        componentData.setProgramData(cloneData);
        componentData.setStudentList(cloneData.students.reduce((acc, studRec)=> {
            (studRec.isSelected) && acc.push(studRec.StudentID);
            return acc;
        },[]));

        componentData.setParentRefresh(true);
    };

    const hasChangedOn = (type, studentID) =>{
        const isPretestChecked = showCheckedPretest(studentID);
        const isPosttestChecked = showCheckedPosttest(studentID);

        const pretestNowOff = (hasPretest && !isPretestChecked);
        const posttestNowOff = (hasPosttest && !isPosttestChecked);
       
        if (type==='Pretest' && !isPosttestChecked) return false;
        if (type==='Posttest' && !isPretestChecked) return false;
        if (type==='Pretest' && pretestNowOff) return true;
        if (type==='Posttest' && posttestNowOff) return true;       
        
        return false;
    };

    const hasChanged = (type, studentID) =>{
        const pretestNowOff = (hasPretest && !showCheckedPretest(studentID));
        const posttestNowOff = (hasPosttest && !showCheckedPosttest(studentID));

        if (isSelected && !pageState.hasMouseInsideModulesPanel) return false;
        
        if (type==='Pretest' && pretestNowOff) return true;
        if (type==='Posttest' && posttestNowOff) return true;       
        
        if (type==='Pretest' && (hasPretest && showCheckedAssignment())) return true;
        if (type==='Posttest' && (hasPosttest && showCheckedAssignment())) return true;         
        
        if (type==='Assignment' && hasAssignment && (showCheckedPretest(studentID) || showCheckedPosttest(studentID))) return true;

        return false;
    };

    return(
        <Row style={selectedStyle}>
            <Col xs='5'>{name}</Col>
            {(componentData.isPretestable)?
            <>
                <Col style={{textAlign: 'center', backgroundColor:backgroundStyleGrey}} xs='2'>{hasChanged('Pretest',StudentID)?<IconClose style={{color: backgroundStyleGreyX}} />:<IconClose style={{color: backgroundStyleGrey}} />}<input type="checkbox" onChange={(e)=>onChangeHandlerPretest(StudentID)(e)} checked={showCheckedPretest(StudentID)} disabled={isPretestDisabled(StudentID)}/></Col>
                <Col style={{textAlign: 'center', backgroundColor:backgroundStyleGrey}} xs='2'>{hasChanged('Posttest',StudentID)?<IconClose style={{color: backgroundStyleGreyX}} />:<IconClose style={{color: backgroundStyleGrey}} />}<input type="checkbox" onChange={(e)=>onChangeHandlerPosttest(StudentID)(e)} checked={showCheckedPosttest(StudentID)} disabled={isPosttestDisabled(StudentID)}/></Col>
            </>:
            <>
                <Col style={{textAlign: 'center', fontSize:'1em', backgroundColor:backgroundStyleGrey}} xs='2'><IconClose style={{color: backgroundStyleGrey}} />N/A</Col>
                <Col style={{textAlign: 'center', fontSize:'1em', backgroundColor:backgroundStyleGrey}} xs='2'><IconClose style={{color: backgroundStyleGrey}} />N/A</Col>
                {/* <Col style={{textAlign: 'center'}} xs='2'><IconClose style={{color: '#EfEfEf'}} /></Col>
                <Col style={{textAlign: 'center'}} xs='2'><IconClose style={{color: '#EfEfEf'}} /></Col> */}
            </>}

            <Col style={{textAlign: 'center'}} xs='3'>{hasChanged('Assignment',StudentID)?<IconClose style={{color: '#ff4f4f'}} />:<IconClose style={{color: backgroundStyle}} />}
                <span onClick={()=>toggleSelected(StudentID)} xs='6' style={{cursor: 'pointer'}} disabled={hasTestsChecked}>
                {(hasAssignment)&&<input type="checkbox" onChange={(e)=>toggleSelected(StudentID)} checked={showCheckedAssignment()} disabled={hasTestsChecked || parentState.madeModuleChanges}/>}
                {(hasAssignment)&&<IconEdit style={{fontWeight:'bold', color:((hasTestsChecked||parentState.madeModuleChanges)?'grey':(assignAuthor==='pretest')?'red':'green'), paddingLeft:'3px'}}/>} 
                </span>
                {(!hasAssignment)&&<input type="checkbox" onChange={(e)=>toggleSelected(StudentID)} checked={showCheckedAssignment()} disabled={hasTestsChecked || parentState.madeModuleChanges}/>}
                {(!hasAssignment)&&<IconEdit style={{fontWeight:'bold', color:backgroundStyle, paddingLeft:'3px'}}/>} 
            </Col>
        </Row>
    );
};

StudentRow.propTypes = {
    data: PropTypes.object,
    state: PropTypes.object,
    progID: PropTypes.string
};

export default ContainerComp;